




































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import { WexDebitCardManageCardViewState, Address } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import * as datadog from "@/shared/datadog";

@Component({
  components: {
  }
})
export default class WexDebitCardDeactivateCardForm extends Vue {
  wexDebitCardsStore = useWexDebitCardsStore();
  contactInfoStore = useContactInfoStore();

  WexDebitCardManageCardViewState = WexDebitCardManageCardViewState;
  RouteNames = RouteNames;

  mounted (): void {
    this.contactInfoStore.getContactInformation();
  }

  get mailingAddress (): Address {
    if (!this.contactInfoStore.contactInformation
      || !this.contactInfoStore.contactInformation.mailingAddress) {
      const data = {
        cardNumberLast4: this.wexDebitCardsStore.RowSelected.cardNumberLast4,
        userDate: Date.now()
      };

      datadog.log(`MailingAddress not found`, data, "error");
      return null;
    }
    return this.contactInfoStore.contactInformation.mailingAddress;
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.wexDebitCardsStore.setWexDebitCardManageCardViewState(WexDebitCardManageCardViewState.ConfirmDeactivateCardForm);
  }
}
